import React from 'react'
import { Alert, Button, Card, Col, Modal, Row } from 'react-bootstrap'
import { observer } from 'mobx-react'
import { observable } from 'mobx'
import { i18nTranslate } from 'src/utils'
import {
  accountsContainer,
  customerContainer,
  storeContainer,
} from 'src/models'
import { languageAbbreviation } from 'src/views/pages/LoginCallback/fixture.js'
import { getLocaleCodeFromUrl, trackMyProfileEvents } from 'src/utils'
import { CommonForm } from 'src/views/components'
import {
  parsePhoneNumberField,
  validLibMobilePhoneNumber,
} from 'src/utils/signUpUtils'
import { pageNames } from 'src/routes/pathParams'
import { BsFillExclamationCircleFill } from 'react-icons/bs'
import { APPConfig } from 'config/appConfig'

@observer
class AccountForm extends React.Component {
  @observable showPopup = false
  @observable formData = []

  FORM = 'FORM'
  POPUP = 'POPUP'
  SUBMIT_BUTTON = 'SUBMIT_BUTTON'
  EMAIL_VERIFIED = 'EMAIL_VERIFIED'

  constructor(props) {
    super(props)
  }

  handleProcess = async (formData = {}) => {
    const prefName = formData.preferredName
    if (prefName === '') {
      customerContainer.updateProfileWithoutPreferredName(formData)
    } else {
      await customerContainer.updateProfile(formData)
      accountsContainer.isSaveChangesBtnClicked = true
    }
  }

  componentDidUpdate() {
    if (accountsContainer.isSaveChangesBtnClicked) {
      accountsContainer.isSaveChangesBtnClicked = false
      this.props.onUpdate()
    }
  }

  customHandleBlur = async ({ values = {} }) => {
    if (values.mobilePhoneNumber !== '') {
      const phoneNumberCode = await parsePhoneNumberField(
        values.mobilePhoneNumber,
        values.phoneCountryCode
      )
      const isValidMobile = await validLibMobilePhoneNumber(phoneNumberCode)
      accountsContainer.phoneNumberIsValid = isValidMobile
    }
    if (values.email != '') {
      accountsContainer.duplicateEmailExist = false
    }
  }

  handleSubmit = formData => {
    const { email, preferredLanguage } = formData
    const exEmail = customerContainer.profileResponse?.email || ''
    const exPreferredLanguage =
      customerContainer?.profileResponse?.customProperties?.preferredLanguage ||
      ''

    /**
     * @info
     * GTM Datalayer - Send event if user updates/changes communication/preferred language.
     */
    if (preferredLanguage !== exPreferredLanguage) {
      const { b2bMyProfile } = pageNames
      trackMyProfileEvents({
        type: 'nuskin-profile',
        categoryName: 'communications',
        eventName: 'Profile - Communication Lang Update',
        preferences: {
          preferredLanguage:
            languageAbbreviation[preferredLanguage.trim()] || '',
        },
      })
      // TagManager.dataLayer({
      //   dataLayer: {
      //     event: 'NuskinProfileCommunicationLangUpdate',
      //     pagePath: b2bMyProfile,
      //     exPreferredLanguage,
      //     newPreferredLanguage: preferredLanguage,
      //     userDetails: {
      //       userId: customerContainer.profileResponse?.id || '',
      //       email: customerContainer.profileResponse?.email || '',
      //       firstName: customerContainer.profileResponse?.firstName || '',
      //       lastName: customerContainer.profileResponse?.lastName || '',
      //     },
      //     pageTitle: 'My Profile',
      //     platform: 'equinox',
      //   },
      // })
    }
    if (email === exEmail) {
      this.handleProcess(formData)
    } else {
      this.showPopup = true
      this.formData = { ...formData }
    }
  }

  handleClosePopup = () => {
    this.showPopup = false
  }

  handleSubmitPopup = () => {
    this.showPopup = false
    this.handleProcess(this.formData)
  }

  getDataModal(dataKey) {
    switch (dataKey) {
      case this.FORM:
        return {
          label: this.props?.label || '',
          schema: this.props?.schema,
          formInput: this.props?.formInput,
          dataTestId: this.props?.dataTestId || '',
        }
      case this.SUBMIT_BUTTON:
        return {
          label: this.props?.button?.label || '',
          dataTestId: this.props?.button?.dataTestId || '',
          message: i18nTranslate(
            'myprofile.submit.message',
            'Please switch to your home market to make any changes.'
          ),
        }
      case this.POPUP:
        return {
          modalTitle: i18nTranslate('emailUpdate', 'Email Update'),
          changeEmailMessage1: i18nTranslate(
            'changeEmailmsg1',
            "You are changing account's primary email for account correspondence and used for logging in.",
            {
              nameSpace: 'ssr-resource',
            }
          ),
          changeEmailMessage2: i18nTranslate(
            'changeEmailmsg2',
            'Are you sure you want to save changes?',
            {
              nameSpace: 'ssr-resource',
            }
          ),
          proceedText: i18nTranslate('myprofile.proceed', 'Proceed'),
        }
      case this.EMAIL_VERIFIED:
        return {
          message: i18nTranslate(
            'myprofile.emailAlert',
            'Please verify your email address.'
          ),
        }
      default:
        return {}
    }
  }

  getStyleGuides(dataKey) {
    switch (dataKey) {
      case this.FORM:
        return {
          classNameValue: {
            formRowClassName: 'mb-2 mb-md-3',
          },
        }
      case this.SUBMIT_BUTTON:
        let homeCountry = storeContainer.currentRegion || ''

        customerContainer?.profileResponse?.accounts?.properties?.forEach(
          (element = {}) => {
            if (element.attributeId === 'countryCode') {
              homeCountry = element.value
            }
          }
        )

        if (homeCountry === 'CA') {
          homeCountry = 'Canada'
        }

        return {
          showMessageClass:
            homeCountry === storeContainer.storeIDValue ? '' : 'd-none',
          hideMessageClass:
            homeCountry === storeContainer.storeIDValue
              ? 'd-none'
              : 'non-home-market-country',
        }
      case this.EMAIL_VERIFIED:
        const isEmailVerifiedFlag =
          customerContainer?.profileResponse?.customProperties
            ?.isEmailVerifiedFlag == 'false' || false
        const isEmailVerifiedRegionSpecific =
          APPConfig?.getAppConfig()?.enableEmailVerifiedMessage || []
        // const homeMarket = getLocalStorage('homeCountry') || ''
        const homeMarket = customerContainer.getUserHomeCountry()
        const curLocale =
          getLocaleCodeFromUrl({
            defaultLocale: 'en_US',
            isReverseType: true,
          }) || ''

        const [language, activeCountry] = curLocale.includes('_')
          ? curLocale.split('_')
          : curLocale.split('-')

        return {
          hideMessageClass:
            isEmailVerifiedFlag &&
            isEmailVerifiedRegionSpecific?.includes(
              homeMarket?.toLowerCase()
            ) &&
            homeMarket?.toLowerCase() === activeCountry?.toLowerCase()
              ? 'alert-verify-text d-flex align-items-center font-weight-bold'
              : 'd-none',
        }
      default:
        return {}
    }
  }

  renderSubmitButton = () => {
    const data = this.getDataModal(this.SUBMIT_BUTTON)
    const styles = this.getStyleGuides(this.SUBMIT_BUTTON)
    return (
      <Row>
        <Col className={styles?.showMessageClass}>
          <Button
            variant="primary"
            type="submit"
            data-testid={data?.dataTestId}
            className="myaccount-btn mt-4 mb-2 md-0">
            {data?.label}
          </Button>
        </Col>
        {customerContainer.isProfileCallOver && (
          <div className={styles?.hideMessageClass}>{data?.message}</div>
        )}
      </Row>
    )
  }

  renderPopup = () => {
    const data = this.getDataModal(this.POPUP)

    return (
      <div>
        <Modal
          show={true}
          onHide={this.handleClosePopup}
          backdrop="static"
          keyboard={false}
          className="modal_box">
          <Modal.Header closeButton>
            <Modal.Title className="text-center">
              {data?.modalTitle}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Alert className="loyaltyAlert" variant="danger">
              {data?.changeEmailMessage1} {data?.changeEmailMessage2}
            </Alert>
            <Button
              className="confirmBtn mb-2 ml-7"
              variant="primary"
              onClick={this.handleSubmitPopup}>
              {data?.proceedText}
            </Button>
          </Modal.Body>
        </Modal>
      </div>
    )
  }

  render() {
    const data = this.getDataModal(this.FORM)
    const emailVerifyData = this.getDataModal(this.EMAIL_VERIFIED) || {}
    const emailVerifyStyle = this.getStyleGuides(this.EMAIL_VERIFIED) || {}
    return (
      <Card
        className="mb-3 shadow-sm"
        data-testid={`${data?.dataTestId}-container`}>
        <Card.Body className="bg-white">
          <h1
            data-testid={`${data?.dataTestId}-heading`}
            className="card-title heading-2-bold card-title h5">
            {data?.label}
          </h1>

          {this.showPopup && this.renderPopup()}
          {customerContainer?.isProfileCallOver && (
            <div className={emailVerifyStyle?.hideMessageClass}>
              <BsFillExclamationCircleFill
                size="1rem"
                className={`tick-icon red`}
              />
              <span>{emailVerifyData?.message}</span>
            </div>
          )}

          {data?.formInput?.length > 0 && (
            <CommonForm
              schema={data?.schema}
              formTypeJson={data?.formInput}
              SubmitButtonProps={this.renderSubmitButton}
              customHandleBlur={this.customHandleBlur}
              onSubmit={this.handleSubmit}
              hasInlineSubmitButton={false}
              classNameValue={data?.classNameValue}
            />
          )}
        </Card.Body>
      </Card>
    )
  }
}

export default AccountForm
